"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MULTISITE_4NKWEB_LINE_HOST = exports.MULTISITE_4NKWEB_LINE_SLUGS = exports.GENERIC_4NKWEB_ENV_SITE_HOST = exports.LECOFFREIO_V2_PUBLIC_HOST = exports.LECOFFREIO_V2_4NKWEB_PUBLIC_HOST = exports.LECOFFREIO_V2_PROD_APP_LECOFFRE_IO_HOST = exports.LECOFFRE_IO_NOTARY_V1_PAGE_HOST = void 0;
exports.parseLecoffreioPublicDeploymentHost = parseLecoffreioPublicDeploymentHost;
exports.isLecoffreioV2PublicDeploymentHostname = isLecoffreioV2PublicDeploymentHostname;
exports.multisite4nkWebLineSlugToDeploymentSiteCode = multisite4nkWebLineSlugToDeploymentSiteCode;
exports.parseMultisite4nkWebLineHost = parseMultisite4nkWebLineHost;
exports.alignMultisite4nkWebLineHostToPageLine = alignMultisite4nkWebLineHostToPageLine;
exports.multisiteBrandingAbsoluteUrlTargetsForeignLine = multisiteBrandingAbsoluteUrlTargetsForeignLine;
const deploymentSiteCodes_1 = require("./deploymentSiteCodes");
function isCabinetLineOfficialBrandingHost(hostname) {
    var _a;
    const h = (_a = hostname.trim().toLowerCase().split(":")[0]) !== null && _a !== void 0 ? _a : "";
    return /^([a-z0-9-]+\.)*[a-z0-9-]+-avocats\.fr$/i.test(h);
}
exports.LECOFFRE_IO_NOTARY_V1_PAGE_HOST = /^(test|pprod|prod)\.lecoffre\.io$/i;
exports.LECOFFREIO_V2_PROD_APP_LECOFFRE_IO_HOST = /^www\.app\.lecoffre\.io$/i;
exports.LECOFFREIO_V2_4NKWEB_PUBLIC_HOST = /^(test|pprod|prod)\.lecoffreio\.4nkweb\.com$/i;
exports.LECOFFREIO_V2_PUBLIC_HOST = exports.LECOFFREIO_V2_4NKWEB_PUBLIC_HOST;
exports.GENERIC_4NKWEB_ENV_SITE_HOST = /^(test|pprod|prod)\.[a-z0-9-]+\.4nkweb\.com$/i;
const MULTISITE_SLUG_ORDER_FOR_REGEX = {
    lecoffreio: 0,
};
exports.MULTISITE_4NKWEB_LINE_SLUGS = [...deploymentSiteCodes_1.DEPLOYMENT_SITE_CODES].sort((a, b) => MULTISITE_SLUG_ORDER_FOR_REGEX[a] - MULTISITE_SLUG_ORDER_FOR_REGEX[b]);
const MULTISITE_4NKWEB_SLUG_ALT = exports.MULTISITE_4NKWEB_LINE_SLUGS.join("|");
exports.MULTISITE_4NKWEB_LINE_HOST = new RegExp(`^(test|pprod|prod)\\.(${MULTISITE_4NKWEB_SLUG_ALT})\\.4nkweb\\.com$`, "i");
function parseLecoffreioPublicDeploymentHost(hostname) {
    var _a;
    const h = (_a = hostname.trim().toLowerCase().split(":")[0]) !== null && _a !== void 0 ? _a : "";
    const from4nk = parseMultisite4nkWebLineHost(h);
    if (from4nk) {
        return from4nk;
    }
    if (exports.LECOFFREIO_V2_PROD_APP_LECOFFRE_IO_HOST.test(h)) {
        return { tier: "prod", slug: "lecoffreio" };
    }
    return null;
}
function isLecoffreioV2PublicDeploymentHostname(hostname) {
    return parseLecoffreioPublicDeploymentHost(hostname) !== null;
}
function multisite4nkWebLineSlugToDeploymentSiteCode(slug) {
    switch (slug) {
        case "lecoffreio":
            return deploymentSiteCodes_1.DEPLOYMENT_SITE_LECOFFREIO;
    }
}
function parseMultisite4nkWebLineHost(hostname) {
    var _a;
    const h = (_a = hostname.trim().toLowerCase().split(":")[0]) !== null && _a !== void 0 ? _a : "";
    const m = exports.MULTISITE_4NKWEB_LINE_HOST.exec(h);
    if (!(m === null || m === void 0 ? void 0 : m[1]) || !m[2]) {
        return null;
    }
    return {
        tier: m[1].toLowerCase(),
        slug: m[2].toLowerCase(),
    };
}
function parseUrlForMultisiteAlign(trimmed) {
    const hasProto = trimmed.includes("://");
    try {
        return { url: new URL(hasProto ? trimmed : `https://${trimmed}`), hasProto };
    }
    catch {
        return null;
    }
}
function multisiteAlignedHostnameOrNull(pageH, cfgHost) {
    const pageLine = parseMultisite4nkWebLineHost(pageH);
    const cfgLine = parseMultisite4nkWebLineHost(cfgHost);
    if (!pageLine || !cfgLine || pageLine.tier !== cfgLine.tier || pageLine.slug === cfgLine.slug) {
        return null;
    }
    const alignedHost = `${pageLine.tier}.${pageLine.slug}.4nkweb.com`;
    if (alignedHost === cfgHost) {
        return null;
    }
    return alignedHost;
}
function alignMultisite4nkWebLineHostToPageLine(pageHostWithOptionalPort, configuredHost) {
    var _a;
    const pageH = (_a = pageHostWithOptionalPort.trim().toLowerCase().split(":")[0]) !== null && _a !== void 0 ? _a : "";
    const trimmed = configuredHost.trim();
    if (!pageH || !trimmed) {
        return configuredHost;
    }
    const parsed = parseUrlForMultisiteAlign(trimmed);
    if (!parsed) {
        return configuredHost;
    }
    const cfgHost = parsed.url.hostname.trim().toLowerCase();
    const alignedHost = multisiteAlignedHostnameOrNull(pageH, cfgHost);
    if (!alignedHost) {
        return configuredHost;
    }
    parsed.url.hostname = alignedHost;
    if (!parsed.hasProto) {
        const port = parsed.url.port ? `:${parsed.url.port}` : "";
        return `${parsed.url.hostname}${port}`;
    }
    return parsed.url.toString().replace(/\/$/, "");
}
function multisiteBrandingAbsoluteUrlTargetsForeignLine(url, expectedDeploymentSiteCode) {
    const t = typeof url === "string" ? url.trim() : "";
    if (t.length === 0 || (!t.startsWith("http://") && !t.startsWith("https://"))) {
        return false;
    }
    let host;
    try {
        host = new URL(t).hostname.toLowerCase();
    }
    catch {
        return false;
    }
    const parsed = parseMultisite4nkWebLineHost(host);
    if (!parsed) {
        if (isCabinetLineOfficialBrandingHost(host)) {
            return true;
        }
        return false;
    }
    const urlLine = multisite4nkWebLineSlugToDeploymentSiteCode(parsed.slug);
    const expected = (0, deploymentSiteCodes_1.normalizeLegacyDeploymentSiteCode)(expectedDeploymentSiteCode);
    return (0, deploymentSiteCodes_1.normalizeLegacyDeploymentSiteCode)(urlLine) !== expected;
}
